if (!customElements.get('pd-hero-picker')) {
  customElements.define('pd-hero-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = Array.from(this.querySelectorAll('[data-picker-tab]'));
      const panels = Array.from(this.querySelectorAll('[data-picker-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;
      this.dataset.ready = 'true';
      const list = this.querySelector('[data-picker-tabs]');
      list.setAttribute('role', 'tablist');
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.dataset.selected = String(active);
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[i].id);
        panels[i].setAttribute('role', 'tabpanel');
        tab.addEventListener('click', event => { event.preventDefault(); select(i); });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (event.key === ' ' || event.key === 'Enter') next = i;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      select(0);
      this.classList.add('is-ready');
    }
  });
}
